export default __webpack_public_path__ + "static/media/credit-not-found.8cf03d13.svg";